import {
  SHStack,
  SHTableCell,
  SHTableRow,
  SHTypography,
} from "@components/design-systems";
import { StarSVG } from "@components/svgs";
import { TableFooter, useTheme } from "@mui/material";
import { memo } from "react";

interface SummaryAnalysisTableFooterProps {
  containsMissingEssential?: boolean;
  containsEssentialFeature?: boolean;
}
export const SummaryAnalysisTableFooter = memo(
  ({
    containsMissingEssential,
    containsEssentialFeature,
  }: SummaryAnalysisTableFooterProps) => {
    const { palette } = useTheme();

    return (
      <TableFooter className="SummaryAnalysisTableFooter">
        <SHTableRow>
          <SHTableCell sx={{ padding: "0px 0px !important" }}>
            {containsMissingEssential && (
              <SHStack className="SummaryAnalysisTableFooter-MissingEssentialNote">
                <SHTypography
                  variant="caption"
                  fontWeight={600}
                  color={palette.error.main}
                  style={{ marginTop: "5px" }}
                >
                  * Missing an essential feature
                </SHTypography>
              </SHStack>
            )}

            {containsEssentialFeature && (
              <SHStack
                className="SummaryAnalysisTableFooter-ContainsEssential"
                spacing={"5px"}
                alignItems={"center"}
                direction={"row"}
              >
                <StarSVG width={"13px"} height={"13px"} />
                <SHTypography
                  variant="body1"
                  colorVariant="third"
                  paddingTop={"4px"}
                >
                  Essential features
                </SHTypography>
              </SHStack>
            )}
          </SHTableCell>
        </SHTableRow>
      </TableFooter>
    );
  },
);
